import Timeslots from '../../booking/modules/timeslots';

// eslint-disable-next-line no-undef
const BASE_URL = `${siteUrl}api/gms/v1/reservation/`;

export default {
    /**
     * Find start times.
     */
    findStartTimes(date, duration) {
        return new Promise((resolve, reject) => {
            axios.get(`${BASE_URL}academy-start-times`, {
                params: {
                    date,
                    duration,
                },
            })
            .then((response) => {
                if (!response.data.success) {
                    throw response.data.errors;
                }

                // Create new array with only the given date.
                const timesPerPro = [];
                for (let i = 0; i < response.data.result.timesPerPro.length; i++) {
                    timesPerPro[i] = {
                        id: response.data.result.timesPerPro[i].id,
                        name: response.data.result.timesPerPro[i].name,
                        startTimes: [],
                    };

                    if (response.data.result.timesPerPro[i].startTimes) {
                        for (let j = 0; j < response.data.result.timesPerPro[i].startTimes.length; j++) {
                            if (response.data.result.timesPerPro[i].startTimes[j].date == date) {
                                timesPerPro[i].startTimes.push(response.data.result.timesPerPro[i].startTimes[j]);
                            }
                        }
                    }
                }

                resolve(timesPerPro);
            })
            .catch((error) => {
                console.error(error);
                reject(error);
            });
        });
    },

    /**
     * Create visit claim.
     *
     * @param {Object} params
     */
    createAcademyClaim(params) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_URL}claim-academy`, params)
            .then((response) => {
                if (!response.data.success) {
                    throw response.data.errors;
                }

                resolve(response);
            })
            .catch((error) => {
                // handle error
                console.error(error);
                reject(error);
            });
        });
    },

    /**
     * Expand info on a temporary lesson claim with lesson type and member id's.
     *
     * @param {Object} params
     */
    updateAcademyLessonMemberClaim(params) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_URL}update-academy-lesson-member-claim`, params)
            .then((response) => {
                if (!response.data.success) {
                    throw response.data.errors;
                }

                resolve(response);
            })
            .catch((error) => {
                // handle error
                console.error(error);
                reject(error);
            });
        });
    },

    /**
     * Calls the GMS Reservation makeVisitDefinitive method.
     *
     * @param {Object} params
     * @returns {Promise}
     */
    makeVisitDefinitive(visitId) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_URL}visit/${visitId}/makeAcademyDefinitive`, postQs({}))
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },
};
